import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37eb169f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-body grid no-gutter ml-2 mr-2 pt-2 pb-2" }

import { withDefaults, ref, onBeforeMount, computed } from "vue";
import { get, set, useDateFormat } from "@vueuse/core";
import FormBooking from "../common/form.vue";
import { IBooking } from "@/clinic/typings";
import { DATE_FORMAT, TIME_FORMAT } from "@/clinic/typings/constants/booking";
import { EventInput } from "@fullcalendar/core";
import { BookingViewPageTypeEnum } from "@/clinic/typings/enums/booking";
import { useRoute } from "vue-router";

type IBodyNewSidebar = {
  booking: IBooking;
  eventArg: EventInput;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'body',
  props: {
    booking: { default: {} as unknown as IBooking },
    eventArg: { default: {} as EventInput }
  },
  emits: ["save", "close"],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { booking: IBooking, eventArg: EventInput };

const route = useRoute();



const onSave = () => emits("save");
const onClose = () => emits("close");



const frmBooking = ref<InstanceType<typeof FormBooking> | null>(null);

const getForm = (): HTMLFormElement => get(frmBooking)?.getForm() as HTMLFormElement;
const validate = (fieldName?: string): boolean => get(frmBooking)?.validate(fieldName) as unknown as boolean;
const booking = ref<IBooking>();
const bookingDate = ref("");
const startTime = ref("");
const endTime = ref("");

// eslint-disable-next-line no-undef
expose({
  getForm,
  validate,
});

const loadEventArgs = (): boolean => {
  const { resource, start: start_time, end: end_time } = props.eventArg;
  let staff_id, room_id;
  if (route.query.view_page == BookingViewPageTypeEnum.StaffCalendar) staff_id = parseInt(resource?.id);
  if (route.query.view_page == BookingViewPageTypeEnum.RoomCalendar) room_id = parseInt(resource?.id);

  set(booking, {
    start_time,
    end_time,
    staff_id,
    room_id,
    is_free_space: props.booking.is_free_space,
  } as unknown as IBooking);
  return true;
};

const loadBookingDate = (): boolean => {
  const { start_time, end_time } = get(booking) as IBooking;
  set(bookingDate, get(useDateFormat(new Date(start_time), DATE_FORMAT)));
  set(startTime, get(useDateFormat(new Date(start_time), TIME_FORMAT)));
  set(endTime, get(useDateFormat(new Date(end_time), TIME_FORMAT)));
  return true;
};

onBeforeMount(() => loadEventArgs() && loadBookingDate());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FormBooking, {
      ref_key: "frmBooking",
      ref: frmBooking,
      model: booking.value,
      bookingDate: bookingDate.value,
      startTime: startTime.value,
      endTime: endTime.value,
      onSave: onSave,
      onClose: onClose
    }, null, 8, ["model", "bookingDate", "startTime", "endTime"])
  ]))
}
}

})